import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import Auth from 'j-toker';

import Launcher from 'components/shared/chatPopup/components/Launcher.js';
import { sortAlphaNum } from 'helpers/utilities';

import { initalizeChat, sendMessage, updateConversation } from 'actions/chatActions';
import { unreadMessages } from 'actions/dashboardActions';
import { toggleChatDrawer } from 'actions/chatActions';
import { deepDiver } from 'helpers/utilities';
import { getTranslatedString } from 'helpers/i18n';
import moment from 'moment';
import { toFriendlyDateString, toTimeString } from 'helpers/Formatter';

const MESSAGES_POLL_INTERVAL_IN_MS = 10000;

let ChatDrawer = class extends Component {
  state = {
    messages: [],
  };

  componentDidMount = () => {
    this.props.initalizeChat(this.props.cotenantId).then(async () => {
      this.messagePolling = this.pollMessages();
    });
  };

  componentWillUnmount() {
    clearInterval(this.messagePolling);
  }

  getUserType = () => {
    if (!this.props.userTypes.loginAuth) {
      return 'lead';
    } else if (this.props.userTypes.loginAuth === 'landlord') {
      return 'agent';
    } else {
      return this.props.userTypes.loginAuth;
    }
  };

  pollMessages = async () => {
    return setInterval(async () => {
      if (this.props.lastMessageTime && !this.props.loadingMessages)
        await this.props.updateConversation(
          this.props.activeConversation.id,
          this.props.lastMessageTime,
          this.props.showChatDrawer
        );
      this.setState({ messages: this.convertMessages(this.props.messages) });
    }, MESSAGES_POLL_INTERVAL_IN_MS);
  };

  isCurrentUser = (messageAuthorType, messageAuthorID) => {
    if (
      messageAuthorType.toLowerCase() === this.getUserType() &&
      messageAuthorID === Auth.user.id
    ) {
      return 'me';
    }

    return 'them';
  };

  convertMessages = () => {
    const textBody = message => {
      if (!message.text) return;

      return {
        author: this.isCurrentUser(message.author_type, message.author_id),
        type: 'text',
        data: message.data,
      };
    };

    const fileBody = message => {
      return {
        author: this.isCurrentUser(message.author_type, message.author_id),
        type: 'file',
        data: {
          url: message.attachment_url,
          fileName: message.attachment_name,
          text: message.text,
          author: message.author_name,
          date: toFriendlyDateString(message.date),
          time: toTimeString(message.date),
        },
      };
    };

    const sortedMessages = this.props.messages.sort((a, b) =>
      sortAlphaNum(a['message_id'], b['message_id'])
    );

    // We set the message_id to an extremely large number so that it is always at the bottom of the chat
    let messages = sortedMessages.filter(
      message => message.id !== 99999999999999999999999999999999
    );
    const lastAuthor = deepDiver(messages[messages.length - 1], 'author_type');

    const agentMessages = this.props.messages.filter(message => message.author_type === 'Agent');
    const agentLastSentTime = deepDiver(agentMessages[agentMessages.length - 1], 'date');
    const agentLastSentOneMinute =
      agentLastSentTime &&
      moment(agentLastSentTime)
        .add(1, 'm')
        .toDate() <= moment().toDate();

    // We set the message_id to an extremely large number so that it is always at the bottom of the chat
    if (lastAuthor === 'Lead' && (agentMessages.length === 0 || agentLastSentOneMinute)) {
      messages.push({
        message_id: 99999999999999999999999999999999,
        author_id: 0,
        author_type: 'Agent',
        author_name: getTranslatedString('messaging.messagingAutoResponseAuthor'),
        author_avatar:
          'https://s3.ca-central-1.amazonaws.com/prod-ca-central-1/leads/avatars/missing/medium/missing_avatar.jpg',
        date: new Date(),
        type: 'text',
        text: getTranslatedString('messaging.messagingAutoResponse'),
        author: getTranslatedString('messaging.messagingAutoResponseAuthor'),
        data: {
          text: getTranslatedString('messaging.messagingAutoResponse'),
          author: getTranslatedString('messaging.messagingAutoResponseAuthor'),
        },
      });
    }

    let convertedMessages = messages.map(message => {
      if (message.attachment_url) {
        return fileBody(message);
      }
      return textBody(message);
    });

    return convertedMessages.filter(message => {
      return message != null;
    });
  };

  _onMessageWasSent = async event => {
    const text = event.data.text.trim();
    await this.props.sendMessage(text, this.props.activeConversation.id, null);
    this.setState({ messages: this.convertMessages(this.props.messages) });
  };

  _onFilesSelected = files => {
    this.props.sendMessage(null, this.props.activeConversation.id, files[0]);
  };

  openChat = () => {
    this.props.unreadMessages(deepDiver(this.props.activeConversation, 'id'), 0);
    this.props.toggleChatDrawer(!this.props.showChatDrawer);
  };

  render() {
    const css = `
    .sc-launcher {
      background-color: #272727;
    }
    .sc-header {
      background-color: #272727;
      font-family: 'Circular-Bold';
      z-index: 125;
    }
    .sc-header--close-button:hover {
      background: #272727;
    }
    .closed :hover {
      background-color: #272727 !important;
    }
    sc-user-input {
      height: 70px;
      padding-top: 6px;
      font-family: 'Circular';
      color: #5d5d5d;
    }
    .sc-header--img {
      height: 52px;
      width: 52px;
      background-image: url(${this.props.chatAvatar});
      background-repeat: no-repeat;
      background-size: 85%;
      background-position: center;
      background-color: white;
    }
    .closed {
      background-color: inherit !important;
    }
    `;

    let messages = this.state.messages;
    if (this.props.messages.length > 0 && this.state.messages.length === 0) {
      messages = this.convertMessages(this.props.messages);
    }

    return (
      <Fragment>
        <style>{css}</style>
        <Launcher
          agentProfile={{
            teamName: this.props.chatName,
            imageUrl: '',
          }}
          onFilesSelected={this._onFilesSelected}
          onMessageWasSent={this._onMessageWasSent}
          messageList={messages}
          newMessagesCount={this.props.tenantOverview.unread_messages}
          handleClick={this.openChat}
          isOpen={this.props.showChatDrawer}
        />
      </Fragment>
    );
  }
};

ChatDrawer = connect(
  store => ({
    messages: store.chat.messages,
    events: store.chat.events,
    conversations: store.chat.conversations,
    activeConversation: store.chat.activeConversation,
    lastMessageTime: store.chat.lastMessageTime,
    lastConversationTime: store.chat.lastConversationTime,
    loadingMessages: store.chat.loadingMessages,
    loadingEvents: store.chat.loadingEvents,
    userTypes: store.userTypes,
    tenantOverview: store.dashboard.tenantOverview,
    showChatDrawer: store.chat.toggleChatDrawer,
  }),
  {
    initalizeChat,
    sendMessage,
    updateConversation,
    unreadMessages,
    toggleChatDrawer,
  }
)(ChatDrawer);

export default localize()(ChatDrawer);
